import { render, staticRenderFns } from "./PropertyStatusDropdown.vue?vue&type=template&id=1f52e204"
import script from "./PropertyStatusDropdown.vue?vue&type=script&lang=js"
export * from "./PropertyStatusDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports